/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box, Button, MenuList } from "@mui/material";

export const InactivityReviewPage = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const ContentContainer = styled('div')({
  padding: '0px 25px',
})

const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return '#61b2fa'
    case 'recovered':
      return '#f5a623'
    case 'decided':
      return '#39cd80'
    default:
      return '#9e9e9e'
  }
}

const getDecisionColor = (decision) => {
  switch (decision) {
    case 'active':
      return '#39cd80'
    case 'inactive':
      return '#f64246'
    case 'expired':
      return '#f5a623'
    default:
      return '#9e9e9e'
  }
}

export const StatusContainer = styled(Box)(({ status }) => ({
  height: "24px",
  minWidth: "130px",
  borderRadius: "6px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getStatusColor(status)}20`,
  color: getStatusColor(status),
  fontSize: '0.775rem',
  padding: '2px 8px',
}));

export const DecisionContainer = styled(Box)(({ decision }) => ({
  height: "24px",
  minWidth: "90px",
  borderRadius: "6px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getDecisionColor(decision)}20`,
  color: getDecisionColor(decision),
  fontSize: '0.775rem',
  padding: '2px 8px',
}));

export const StyledDecisionButton = styled(Button)({
  '&:hover': {
    backgroundColor: 'transparent'
  },
  textTransform: 'none',
  minWidth: 'unset',
  padding: 0,
  justifyContent: 'flex-start'
})

export const DecisionMenuList = styled(MenuList)({
  padding: '6px',
})

export const decisionPopoverPaperStyle = {
  mt: '6px',
  borderRadius: '10px',
  boxShadow: '0 12px 30px rgba(15, 23, 42, 0.14)',
  border: '1px solid #e5e7eb',
  minWidth: '132px',
}

export const decisionMenuItemStyle = {
  borderRadius: '8px',
  fontSize: '0.8125rem',
  minHeight: '34px',
  px: 1.25,
  textTransform: 'none',
}

export const BulkActionContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '10px',
  gap: '10px',
})

export const SelectionCount = styled('span')({
  fontSize: '0.8125rem',
  color: '#727272',
  marginRight: 'auto',
})

export const BulkActiveButton = styled(Button)({
  '&:hover': {
    boxShadow: 'none !important',
    border: '2px solid #001b59',
    color: '#001b59',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  border: '2px solid #395bbd',
  borderRadius: '8px',
  color: '#395bbd',
})

export const BulkInactiveButton = styled(Button)({
  '&:hover': {
    boxShadow: 'none !important',
    border: '2px solid #c62828',
    color: '#c62828',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  border: '2px solid #f64246',
  borderRadius: '8px',
  color: '#f64246',
})

export const brandLogoStyle = {
  width: '270px',
  height: '100%',
};

export const userButtonContainerStyle = {
  marginRight: '20px',
};

export const ArchivedNote = styled('span')({
  fontSize: '0.6875rem',
  color: '#a3a3a3',
  display: 'block',
})
